export const relationshipOptions = [
  {
    text: '続柄を選択してください',
    value: null
  },
  {
    text: '父',
    value: 'father'
  },
  {
    text: '母',
    value: 'mother'
  },
  {
    text: '祖父',
    value: 'grandfather'
  },
  {
    text: '祖母',
    value: 'grandmother'
  },
  {
    text: '兄',
    value: 'brother'
  },
  {
    text: '姉',
    value: 'sister'
  },
  
  {
    text: '叔父',
    value: 'uncle'
  },
  {
    text: '叔母',
    value: 'aunt'
  },
  {
    text: 'その他',
    value: 'other'
  }
]

export const relationshipByValue = {
  father: '父',
  mother: '母',
  grandfather: '祖父',
  grandmother: '祖母',
  brother: '兄',
  sister: '姉',
  uncle: '叔父',
  aunt: '叔母',
  other: 'その他',
  self: '本人'
}